import { css } from 'styled-components';
import base from '../../foundation/Theme/variant/base';
/**
 * Media query mixin for setting resolution boundaries.
 * The output of this mixin is an object with breakpoints
 * as its properties, and each of the properties pointing
 * to an function for generating a media query at that
 * breakpoint like this: {xs: ƒ, sm: ƒ, md: ƒ, lg: ƒ, xl: ƒ}.
 * @example
 * // styled-components usage
 * ${media.lg`
 *   padding: 20px;
 *   margin: 0 auto;
 * `}
 */

var breakpoints = base.grid.breakpoints;
/**
 * styled-bootstrap-grid also exposes the media element for breakpoints.
 * It works, but it doesn't utilise the customised breakpoints we set
 * for this project, instead it stuck with the default ones. That's why
 * we had to come up with our own styled media object.
 */

export var media = Object.keys(breakpoints).reduce(function (acc, prop) {
  /**
   * Given the current set up, it is assumed that "xs" is the smallest
   * breakpoint which covers everything below it, and will be used with
   * "max-width" query.
   */
  acc[prop] = function () {
    return css(["@media (", ":", "){", "}"], prop === 'xs' ? 'max-width' : 'min-width', breakpoints[prop], css.apply(void 0, arguments));
  };

  return acc;
}, {});